import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs';
import { fileService } from 'src/app/front-user/shared/services/file.service';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { AppConfig } from 'src/app/shared/services/app.config';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { WFHistoryService } from 'src/app/shared/services/wfhistory.service';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { FormMode, Languages, ServiceStatus, TransitRequestWFSteps } from 'src/app/shared/models/enums.model';
import { User } from 'src/app/front-user/shared/models/user.model';
import { TransitRequestCustomDTO } from 'src/app/shared/models/transit-request-custom-dto.model';
import { TransitService } from 'src/app/front-user/services/e-booking/transit-request/transit-request.service';
import { Router } from '@angular/router';
import { TransitRequestComponent } from '../transit-request/transit-request.component';
import { FeesEstimate } from '../fees-estimation-request/fees-estimate.model';

@Component({
  selector: 'app-guarantee-deduction-letters',
  templateUrl: './guarantee-deduction-letters.component.html'
})
export class GuaranteeDeductionLettersComponent implements OnInit {
  guaranteeForm: FormGroup;
  uploadUrl = AppConfig.settings.apiServer.UploadsUrl;
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  stepId: number = TransitRequestWFSteps.AgentDeductionLetterAndGuarantee;
  @ViewChild('TransitRequest', { static: false }) TransitRequest: TransitRequestComponent;
  @Input() public isShow: boolean = true;
  @Output() FeesEstimateObjValue = new EventEmitter<FeesEstimate>();
  ServiceStatus = ServiceStatus;
  submitted = false;
  showRequest = false;
  isErrorMessage = false;
  lockTaskErrorMessage = false;
  loading = false;
  baseRequestId: string = '';
  requestStatus: number;
  baseRequestDTO: BaseRequest;
  displayedLang: string;
  currentUser: User = new User();
  isLoaded: boolean = false;
  responseObj: ResponseObject = new ResponseObject();
  agentId: string;
  guaranteeProgress: number = 0;
  deductionProgress: number = 0;
  additionalChequeProgress: number = 0;
  stepHistoryId: any;
  stepData: any;
  transitRequestCustomObj: TransitRequestCustomDTO = new TransitRequestCustomDTO();
  FeesEstimateObj: FeesEstimate = new FeesEstimate();
  uploadFolder = AppConfig.settings.apiServer.EBookingUploadsFolder || 'EBooking';
  guaranteeURL: string = "";
  deductionURL: string = "";
  additionalChequeURL: string = "";
  feesEstimationStatus: number;
  showDesclaimerMessage: boolean = false;
  modificationReason: any;
  showModificationReason: boolean = false;
  requestStatuses: number[];
  latestStepId: number;

  constructor(
    private fb: FormBuilder,
    private fileService: fileService,
    private translate: TranslateService,
    private alertService: AlertService,
    private baseRequestService: BaseRequestService,
    private globalSrv: GlobalServices,
    private wfhistoryService: WFHistoryService,
    private transitService: TransitService,
    private router: Router,
  ) {
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    if (history.state.data && history.state.data.requestId) {
      this.stepHistoryId = history.state.data.stepHistoryId;
      this.baseRequestId = history.state.data.requestId;
      // this.baseRequestId = "A1EABCF5-33FE-427C-A871-93ECEEF05F0F";
      this.getBaseRequest();
    } else {
      window.history.back();
    }
    this.currentUser = this.globalSrv.user;
  }

  ngOnInit() {
    this.buildForm(null);
  }

  buildForm(formMode) {
    this.guaranteeForm = this.fb.group({
      GuaranteeLetter: [''],
      DeductionLetter: ['', Validators.required],
      AdditionalCheque: [''],
      CommitToPayPenalties: [false, Validators.requiredTrue]
    });
    if (formMode == FormMode.Edit) {
      this.guaranteeForm = this.fb.group({
        GuaranteeLetter: [''],
        DeductionLetter: [''],
        AdditionalCheque: [''],
        CommitToPayPenalties: [false, Validators.requiredTrue]
      });
    }
  }

  receiveFeesValue(event) {
    this.FeesEstimateObj = event;
    if (this.baseRequestId && this.FeesEstimateObj) {
      this.feesEstimationStatus = this.FeesEstimateObj.StatusId;
      if (this.feesEstimationStatus != ServiceStatus.EstimationRequestCompleted) {
        this.showDesclaimerMessage = true;
      }
      this.FeesEstimateObjValue.emit(this.FeesEstimateObj);
    }
  }

  receiveLatestStepId(event) {
    if (event === undefined) return;
    this.latestStepId = event;
    this.handleLatestStep();
  }

  handleLatestStep() {
    if (!this.latestStepId) return;
    this.isLoaded = true;
    if (this.router.url.split('/')[2].includes('guaranteeDeductionLetters') && this.latestStepId === TransitRequestWFSteps.ConfirmFeesPayment) {
      this.getConfirmFeesPaymentDecisionData();
    }
  }

  getBaseRequest() {
    this.baseRequestService.getBaseRequest(this.baseRequestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        // this.requestStatus = this.baseRequestDTO.StatusId;
        this.requestStatuses = this.baseRequestDTO.RequestStatuses.map(s => s.StatusId);
        this.isLoaded = true;
        if (history.state.data && history.state.data.isCompleted && history.state.data.StepId == this.stepId) { // Request History
          this.formMode = FormMode.Readonly;
          this.getTransitRequestWFHistoryById();
        } else if (this.router.url.split('/')[2].includes('guaranteeDeductionLetters')) {
          this.formMode = FormMode.Add;
          if (this.latestStepId) {
            this.handleLatestStep();
          }
        } else {
          this.formMode = FormMode.Readonly;
          this.getTransitRequestWFHistory();
        }
        // else if (this.requestStatus != ServiceStatus.Transit_PendingAgentDocuments) {
        //   if (this.requestStatus == ServiceStatus.Transit_MoreInformationRequiredFromAgent) {
        //     this.formMode = FormMode.Edit;
        //     this.getConfirmFeesPaymentDecisionData();
        //   } else {
        //     this.formMode = FormMode.Readonly; /// ToBe Fixed After Implementation of Multi Status
        //   }
        //   this.getTransitRequestWFHistory();
        // }

      }
    );
  }
  getConfirmFeesPaymentDecisionData() {
    // Get Step Data of Confirm Fees Payment Decision
    this.wfhistoryService.getByRequestIdByStepId(this.baseRequestId, TransitRequestWFSteps.ConfirmFeesPayment).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.stepData = this.responseObj.Data["StepData"] ? JSON.parse(this.responseObj.Data["StepData"]) : null;
          if (!this.stepData) {
            this.formMode = FormMode.Add;
          } else {
            this.formMode = FormMode.Edit;
            this.getTransitRequestWFHistory();
            this.modificationReason = this.stepData.ModificationReason;
            this.showModificationReason = true;
          }
        }
      }
    );
  }

  getTransitRequestWFHistory() {
    this.wfhistoryService.getByRequestIdByStepId(this.baseRequestId, this.stepId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.stepData = this.responseObj.Data["StepData"] ? JSON.parse(this.responseObj.Data["StepData"]) : null;
          this.getTransitRequestWFHistoryCompleted(this.stepData);
        }
      }
    );
  }

  getTransitRequestWFHistoryById() {
    this.wfhistoryService.getByRequestIdByStepIdById(this.baseRequestId, this.stepId, this.stepHistoryId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        this.stepData = this.responseObj.Data["StepData"] ? JSON.parse(this.responseObj.Data["StepData"]) : null;
        this.getTransitRequestWFHistoryCompleted(this.stepData);
      }
    );
  }

  getTransitRequestWFHistoryCompleted(stepData: any) {
    if (!stepData) return;
    if (this.formMode == FormMode.Readonly) {
      if (stepData.GuaranteeLetter && stepData.GuaranteeLetter != "") {
        this.guaranteeURL = this.uploadUrl + this.uploadFolder + '/' + stepData.GuaranteeLetter;
        this.guaranteeForm.get('GuaranteeLetter')?.setValue(this.guaranteeURL);
      }
      if (stepData.DeductionLetter && stepData.DeductionLetter != "") {
        this.deductionURL = this.uploadUrl + this.uploadFolder + '/' + stepData.DeductionLetter;
        this.guaranteeForm.get('DeductionLetter')?.setValue(this.deductionURL);
      }
      if (stepData.AdditionalCheque && stepData.AdditionalCheque != "") {
        this.additionalChequeURL = this.uploadUrl + this.uploadFolder + '/' + stepData.AdditionalCheque;
        this.guaranteeForm.get('AdditionalCheque')?.setValue(this.additionalChequeURL);
      }
      this.guaranteeForm.get('CommitToPayPenalties')?.setValue(stepData.CommitToPayPenalties);
      this.guaranteeForm.disable();
    } else {
      this.buildForm(this.formMode);
      if (stepData.GuaranteeLetter && stepData.GuaranteeLetter != "") {
        this.guaranteeURL = this.uploadUrl + this.uploadFolder + '/' + stepData.GuaranteeLetter;
        this.guaranteeForm.get('GuaranteeLetter')?.setValue(stepData.GuaranteeLetter);
        this.guaranteeForm.get('GuaranteeLetter')?.disable();
      }
      if (stepData.DeductionLetter && stepData.DeductionLetter != "") {
        this.deductionURL = this.uploadUrl + this.uploadFolder + '/' + stepData.DeductionLetter;
        this.guaranteeForm.get('DeductionLetter')?.setValue(stepData.DeductionLetter);
        this.guaranteeForm.get('DeductionLetter')?.disable();
      }
      if (stepData.AdditionalCheque && stepData.AdditionalCheque != "") {
        this.additionalChequeURL = this.uploadUrl + this.uploadFolder + '/' + stepData.AdditionalCheque;
        this.guaranteeForm.get('AdditionalCheque')?.setValue(stepData.AdditionalCheque);
        this.guaranteeForm.get('AdditionalCheque')?.disable();
      }
    }

  }

  uploadFile(
    event: any,
    controlName: string,
    documentName: string,
    onProgressUpdate: (progress: number) => void
  ): void {
    const file: File = event?.target?.files && event.target.files[0];
    if (!file) { return; }
    this.alertService.clear();

    if (!this.fileService.IsFileExtentionValid(event)) {
      this.guaranteeForm.get(controlName)?.setValue('');
      this.translate.get('FRONT_USER.NotAllowedFileExtentionMessage').subscribe(m => this.alertService.error(m));
      return;
    }
    if (!this.fileService.IsFileSizeValid(event)) {
      this.guaranteeForm.get(controlName)?.setValue('');
      this.translate.get('FRONT_USER.NotAllowedFileSize').subscribe(m => this.alertService.error(m));
      return;
    }

    onProgressUpdate(0);
    this.guaranteeForm.get(controlName)?.setValue(file.name);

    const formData = new FormData();
    formData.append('File', file);
    formData.append('DocumentName', documentName);
    formData.append('FolderName', this.uploadFolder);

    this.fileService.fileUploader(formData).subscribe(evt => {
      if (evt.type === HttpEventType.UploadProgress) {
        onProgressUpdate(Math.round(100 * evt.loaded / (evt.total || 1)));
      } else if (evt instanceof HttpResponse) {
        const data = evt.body?.Data || null;
        const url = data?.Url || data?.UrlPath || data?.Path || null;
        if (url) {
          // store URL in the form so it will be included when submitting
          this.guaranteeForm.get(controlName)?.setValue(url);
          this.guaranteeForm.get(controlName)?.setErrors(null);
        } else {
          this.translate.get('FRONT_USER.FILE_UPLOAD_FAILED').subscribe(m => this.alertService.error(m));
        }
      }
    }, err => {
      onProgressUpdate(0);
      this.translate.get('FRONT_USER.FILE_UPLOAD_FAILED').subscribe(m => this.alertService.error(m));
    });
  }

  onGuaranteeFileSelected(event: any): void {
    this.uploadFile(
      event,
      'GuaranteeLetter',
      'GuaranteeLetter',
      (progress) => { this.guaranteeProgress = progress; }
    );
  }

  onDeductionFileSelected(event: any): void {
    this.uploadFile(
      event,
      'DeductionLetter',
      'DeductionLetter',
      (progress) => { this.deductionProgress = progress; }
    );
  }

  onAdditionalChequeFileSelected(event: any): void {
    this.uploadFile(
      event,
      'AdditionalCheque',
      'AdditionalCheque',
      (progress) => { this.additionalChequeProgress = progress; }
    );
  }

  get f() { return this.guaranteeForm.controls; }

  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.guaranteeForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.transitRequestCustomObj.RequestId = this.baseRequestId;
    this.transitRequestCustomObj.StepId = this.stepId;
    this.transitRequestCustomObj.StepData = JSON.stringify(this.guaranteeForm.getRawValue());
    this.transitRequestCustomObj.CompletedBy = this.currentUser.UserName;
    this.transitRequestCustomObj.ComponentURL = this.router ? this.router.url.split('/')[1] + '/' + this.router.url.split('/')[2] : '';
    this.transitRequestCustomObj.IsAdmin = this.currentUser.IsAdmin;
    this.transitRequestCustomObj.DirectionId = this.TransitRequest.feesRequest.feesDetailsForm.get('DirectionId')?.value;

    this.transitService.SubmitGuaranteeDeductionLetters(this.transitRequestCustomObj)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.guaranteeForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages && data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            this.loading = false;
          }

        });
  }
}
